import { Text } from "ui/Typography"
import useSummaryDetails from "../../hooks/useSummaryDetails"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import SummaryKeyValue from "../../SummaryKeyValue"

const OriginalPriceDetails = ({ originalPriceHistory }) => {
  const { payment_summary } = originalPriceHistory || {}
  const { t } = useTranslation()

  const summaryDetails = useSummaryDetails(payment_summary)
  const { total_price = 0, remaining_balance = 0 } = payment_summary ?? {}

  const detailsWithTotals = [
    ...summaryDetails,
    { labelKey: "client.client_booking.total", value: total_price, fw: 700 },
    { labelKey: "client.payment.labels.remaining_balance", value: remaining_balance, fw: 700 }
  ]

  return (
    <Flex vertical gap={spacings.XS} className="px-xl py-s">
      <Text fw={500} size="lg">
        {t("client.payment.labels.price_details")}
      </Text>
      <SummaryKeyValue details={detailsWithTotals} valueAlign="right" />
    </Flex>
  )
}

OriginalPriceDetails.propTypes = {
  originalPriceHistory: PropTypes.object
}

export default OriginalPriceDetails
